import styled from '@emotion/styled';

const ImageWrapper = styled('img')(
  {
    objectFit: 'contain',
    objectPosition: 'center',
    width: 67,
    height: 67,
    borderRadius: 6,
    marginRight: 10
  },
  ({ theme }) => ({
    border: `1px solid ${theme.palette.colors.columbiaBlue}`
  })
);

export default ImageWrapper;
